import http from './http'

const usuarioService = {
  getAll: page => http.get(`/usuarios?page=${page}`).then(result => result.data),
  getById: id => http.get(`/usuarios/${id}`).then(result => result.data.data),
  getByNome: (str, page) => http.get(`/usuariosdescr/${str}?page=${page}`).then(result => result.data),
  getAllSemPaginar: () => http.get(`/usuariosall`).then(result => result.data),
  delete: id => http.delete(`/usuariosdelete/${id}`),
  alterarSenha: data => http.post(`/alterar-senha`, data),
  // save: data => http.post(`/usuarios`, data).then(result => result.data),
  savePost: data => http({
    method: 'post',
    url: `/usuarios`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/usuarios/${data.id}`,
    data
  }).then(result => result.data.data)
}
//  save: data => http({
//    method: data.id ? 'put' : 'post',
//    url: data.id ? `/usuarios/${data.id}` : '/usuarios',
//    data
//  }),
// }
export default usuarioService
